var React = require('react');

function Availability (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.0912 10.7502C20.2527 10.7502 17.9322 13.0899 17.9322 16.0002C17.9322 18.9106 20.2527 21.2502 23.0912 21.2502C25.9298 21.2502 28.2503 18.9106 28.2503 16.0002C28.2503 13.0899 25.9298 10.7502 23.0912 10.7502ZM16.4729 15.2502C16.8406 11.8837 19.6543 9.25024 23.0912 9.25024C26.7797 9.25024 29.7503 12.2832 29.7503 16.0002C29.7503 19.7173 26.7797 22.7502 23.0912 22.7502C19.6543 22.7502 16.8406 20.1168 16.4729 16.7502H3.00031V15.2502H16.4729ZM9.00037 19.7498L3.00037 19.7502L3.00024 18.2502L9.00024 18.2498L9.00037 19.7498Z","fill":"#2E2B26"}));
}

Availability.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Availability;

Availability.default = Availability;
